import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Nudges contractors to add their TRN so vendor e-invoices carry a complete customer tax number.
export const BuyerTrnBanner = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem("matiqs_trn_nudge_dismissed") === "1");
  if (!user || user.account_type !== "contractor" || user.vat_number || hidden) return null;

  const dismiss = () => {
    localStorage.setItem("matiqs_trn_nudge_dismissed", "1");
    setHidden(true);
  };

  return (
    <div data-testid="buyer-trn-banner" className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1.5 px-4 py-3 rounded-xl border border-sky-300 bg-sky-50 dark:bg-sky-950/30 dark:border-sky-900">
      <Receipt className="w-4 h-4 text-sky-700 dark:text-sky-300 shrink-0" />
      <span className="text-sm text-sky-900 dark:text-sky-200 flex-1 min-w-[220px]">
        Add your <b>TRN</b> in your Company Profile so the tax invoices your vendors issue carry your complete tax number.
      </span>
      <Link data-testid="buyer-trn-banner-cta" to="/profile"
            className="text-sm font-bold text-sky-700 dark:text-sky-300 hover:underline">
        Add TRN
      </Link>
      <button data-testid="buyer-trn-banner-dismiss" onClick={dismiss}
              className="text-sky-700/70 dark:text-sky-300/70 hover:text-sky-900 dark:hover:text-sky-100">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
